module.exports = __webpack_public_path__ + "static/media/endereco.84c2f9b1.svg";